import b, { computed as f, ref as h } from "vue";
b.util.warn;
const m = [
  {
    grey: "https://luna-dict-community.nosdn.127.net/7b63d29c7c8fc340858a81447408e63c.png",
    light: "https://ydlunacommon-cdn.nosdn.127.net/62478fdb1d7b13403bb8d687c5dfb37b.png"
  },
  {
    grey: "https://luna-dict-community.nosdn.127.net/ae3b4b07a09823bf38d7bb815c6ea139.png",
    light: "https://ydlunacommon-cdn.nosdn.127.net/2201d25c563b5299fb36c4a871ad6af1.png"
  },
  {
    grey: "https://luna-dict-community.nosdn.127.net/64e63d8a45a00599d8f4eb67b70f6883.png",
    light: "https://ydlunacommon-cdn.nosdn.127.net/079731f8e45f4eead964d2c0aa2af18b.png"
  },
  {
    grey: "https://luna-dict-community.nosdn.127.net/84cbd355815f9b4958723ebffaddac96.png",
    light: "https://ydlunacommon-cdn.nosdn.127.net/b5273130c2224c84037cedbf5bcb7528.png"
  }
], _ = [
  "https://ydlunacommon-cdn.nosdn.127.net/3c84cc978e0e0c5663053462c9582357.png",
  "https://ydlunacommon-cdn.nosdn.127.net/527dc04a668d4bcedfda67b7f2c99b1d.png",
  "https://ydlunacommon-cdn.nosdn.127.net/bfc70cc63a00701ede49639a45d60445.png",
  "https://ydlunacommon-cdn.nosdn.127.net/32c57b471ce1cc30d2517721087f3a60.png"
], C = [
  {
    title: "教育",
    items: [
      {
        title: "有道智慧教育",
        type: "link",
        value: "https://zhihui.youdao.com/"
      },
      {
        title: "中国大学MOOC",
        type: "link",
        value: "https://www.icourse163.org/"
      },
      {
        title: "网易有道校企合作",
        type: "link",
        value: "https://school.youdao.com/"
      }
    ]
  },
  {
    title: "关于有道",
    items: [
      {
        title: "有道介绍",
        type: "link",
        value: "http://shared.youdao.com/www/about.html"
      },
      {
        title: "投资者关系",
        type: "link",
        value: "https://ir.youdao.com/#/"
      },
      {
        title: "社会责任",
        type: "link",
        value: "https://shared.youdao.com/dict/market/dictLawPdfRead/oldv1/web/viewer.html?file=https://shared.ydstatic.com/dict/market/socialResponsibility/%E6%9C%89%E9%81%932022%E7%A4%BE%E4%BC%9A%E8%B4%A3%E4%BB%BB%E6%8A%A5%E5%91%8A.pdf"
      },
      {
        title: "同道计划",
        type: "link",
        value: "https://tongdao.youdao.com/",
        rlog: "footer_3_4"
      },
      {
        title: "廉正举报",
        type: "link",
        value: "https://jubao.163.com/",
        rlog: "footer_3_5"
      },
      {
        title: "联系我们",
        type: "link",
        value: "http://shared.youdao.com/www/contactus-page.html"
      }
    ]
  },
  {
    title: "加入有道",
    items: [
      {
        title: "校园招聘",
        type: "link",
        value: "http://hr.youdao.com/"
      },
      {
        title: "社会招聘",
        type: "link",
        value: "https://hr.163.com/"
      }
    ]
  },
  {
    title: "相关资质",
    items: [
      {
        title: "营业执照",
        type: "link",
        value: "https://c.youdao.com/dict/law/business_license.html"
      },
      {
        title: "出版物经营许可证",
        type: "link",
        value: "https://c.youdao.com/dict/law/publicationLicense.html"
      },
      {
        title: "广播电视节目<br/>制作许可证",
        type: "link",
        value: "https://c.youdao.com/dict/law/RadioAndTelevisionProgramProductionLicense.html"
      }
    ]
  },
  {
    title: "用户资质",
    items: [
      {
        title: "隐私政策",
        type: "link",
        value: "https://c.youdao.com/dict/law/youdao_agreement/privacy.html"
      },
      {
        title: "服务条款",
        type: "link",
        value: "http://xue.youdao.com/sw/m/1191866"
      }
    ]
  },
  {
    title: "企业",
    items: [
      {
        title: "有道智云 · AI 开放平台",
        type: "link",
        value: "https://ai.youdao.com/?keyfrom=fanyi-new-nav#/"
      },
      {
        title: "有道智选",
        type: "link",
        value: "https://dsp.youdao.com/#/index"
      },
      {
        title: "Youdao Ads",
        type: "link",
        value: "https://youdaoads.com/",
        rlog: "footer_2_3"
      },
      {
        title: "有道人工翻译",
        type: "link",
        value: "https://f.youdao.com/",
        rlog: "footer_2_4"
      }
    ]
  }
];
var k = function() {
  var t = this, e = t._self._c, c = t._self._setupProxy;
  return e("div", { staticClass: "footer", class: `footer-${t.theme}` }, [e("div", { staticClass: "footer-container center_container" }, [e("div", { staticClass: "official-code" }, [e("img", { staticClass: "logo", attrs: { src: "https://luna-dict-community.nosdn.127.net/db2266e756ded7094c5dcbeebd1e6a8b.png" } }), t.showFanYiWechat ? [t._m(0), e("div", { staticClass: "channel-area-title" }, [t._v("更多新动态")])] : t._e(), e("div", { staticClass: "select-channel_area" }, [t._l(c.currentChannelLogoList, function(o, l) {
    return e("img", { key: `channel-logo_${l}`, ref: "channelRef", refInFor: !0, staticClass: "channel-logo", attrs: { src: o.grey }, on: { mouseenter: function(s) {
      return c.selectChannel(l, "enter");
    }, mouseleave: function(s) {
      return c.selectChannel(l, "leave");
    } } });
  }), e("img", { ref: "codeRef", staticClass: "qr-code", attrs: { src: c.channelPic } })], 2)], 2), e("div", { staticClass: "foot-content" }, t._l(c.footerList, function(o, l) {
    return e("ul", { key: `footer-list${l}`, staticClass: "foot-list" }, [e("li", { staticClass: "list-cell list-title" }, [t._v(t._s(o.title))]), t._l(o.items, function(s, u) {
      return e("li", { key: `${s.title}-${u}`, staticClass: "list-cell" }, [s.type === "link" ? e("a", { staticClass: "value", attrs: { href: s.value, target: "_blank" }, domProps: { innerHTML: t._s(s.title) } }) : s.type === "text" ? e("span", { domProps: { innerHTML: t._s(s.title) } }) : s.type === "title" ? e("span", { staticClass: "list-title_inline", domProps: { innerHTML: t._s(s.title) } }) : t._e()]);
    })], 2);
  }), 0)]), e("div", { staticClass: "copyright" }, [e("a", { staticClass: "link", attrs: { href: "http://www.163.com/", target: "_blank" } }, [t._v("©" + t._s((/* @__PURE__ */ new Date()).getFullYear()) + "网易公司")]), e("span", { staticClass: "text" }, [t._v("京ICP证080268号")]), e("a", { staticClass: "link", attrs: { href: "http://beian.miit.gov.cn/", target: "_blank" } }, [t._v("京ICP备10005211号")]), e("a", { staticClass: "link", attrs: { href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020092", target: "_blank" } }, [t._v("京公网安备 11010802020092号")])]), t._m(1)]);
}, w = [function() {
  var n = this, t = n._self._c;
  return n._self._setupProxy, t("div", { staticClass: "wechat-container" }, [t("img", { staticClass: "wechat-qrcode", attrs: { src: "https://ydlunacommon-cdn.nosdn.127.net/d4420720818e84a2cefb493dc0315992.png" } }), t("p", [n._v("关注公众号"), t("br"), n._v("获取更多服务")])]);
}, function() {
  var n = this, t = n._self._c;
  return n._self._setupProxy, t("div", { staticClass: "report" }, [t("a", { staticClass: "link", attrs: { href: "https://c.youdao.com/dict/law/complaint.html", target: "_blank" } }, [n._v("不良信息举报")]), t("a", { staticClass: "link", attrs: { href: "https://www.12377.cn/", target: "_blank" } }, [n._v("网上有害信息举报专区")]), t("div", { staticClass: "text" }, [n._v("网易廉政举报："), t("a", { staticClass: "mail-text", attrs: { href: "mailto:jb@rd.netease.com" } }, [n._v("jb@rd.netease.com")])]), t("div", { staticClass: "parting" }), t("div", { staticClass: "text" }, [n._v("违法和不良信息举报电话：4006666696")]), t("div", { staticClass: "text" }, [n._v("举报邮箱（涉未成年人）：youdao_jubao@rd.netease.com")])]);
}];
function L(n, t, e, c, o, l, s, u) {
  var a = typeof n == "function" ? n.options : n;
  t && (a.render = t, a.staticRenderFns = e, a._compiled = !0), c && (a.functional = !0), l && (a._scopeId = "data-v-" + l);
  var i;
  if (s ? (i = function(r) {
    r = r || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !r && typeof __VUE_SSR_CONTEXT__ < "u" && (r = __VUE_SSR_CONTEXT__), o && o.call(this, r), r && r._registeredComponents && r._registeredComponents.add(s);
  }, a._ssrRegister = i) : o && (i = u ? function() {
    o.call(
      this,
      (a.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : o), i)
    if (a.functional) {
      a._injectStyles = i;
      var p = a.render;
      a.render = function(g, v) {
        return i.call(v), p(g, v);
      };
    } else {
      var d = a.beforeCreate;
      a.beforeCreate = d ? [].concat(d, i) : [i];
    }
  return {
    exports: n,
    options: a
  };
}
const $ = {
  name: "DictWebsiteFooter"
}, P = /* @__PURE__ */ Object.assign($, {
  props: {
    theme: {
      // 主题
      type: String,
      default: "default"
      // grey
    },
    showFanYiWechat: {
      // 显示翻译公众号
      type: Boolean,
      default: !0
    }
  },
  setup(n) {
    const t = n, e = f(() => t.showFanYiWechat ? m.slice(1) : m), c = f(() => t.showFanYiWechat ? _.slice(1) : _), o = h(""), l = h(null), s = h(null);
    return { __sfc: !0, props: t, currentChannelLogoList: e, currentChannelCodeList: c, channelPic: o, channelRef: l, codeRef: s, selectChannel: (a, i) => {
      const p = l.value[a], d = s.value;
      i === "enter" ? (p.src = e.value[a].light, o.value = c.value[a], d.className.includes(`code${a}`) || (d.className += ` code${a}`)) : (p.src = e.value[a].grey, o.value = "", d.className.includes(`code${a}`) && (d.className = d.className.replace(` code${a}`, "")));
    }, ref: h, computed: f, channelLogoList: m, channelCodeList: _, footerList: C };
  }
});
var R = /* @__PURE__ */ L(
  P,
  k,
  w,
  !1,
  null,
  null,
  null,
  null
);
const y = R.exports;
y.install = (n, t) => {
  n.component("DictWebsiteFooter", y);
};
export {
  y as default
};
